import React from "react";
import ReactDOM from "react-dom/client";
import singleSpaReact from "single-spa-react";

import VerticalSliderComponent from "./root.component.js";

function domElementGetter() {
  return document.getElementById("verticalSlider");
}

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: VerticalSliderComponent,
  domElementGetter,
  renderType: "createRoot"
});

export const bootstrap = [reactLifecycles.bootstrap];
export const unmount = [reactLifecycles.unmount];

export function mount(props) {
  return reactLifecycles.mount(props);
}
